export enum ParameterType {
  Options = 0,
  String = 1,
  Boolean = 2,
  Number = 3
}

export default ParameterType;
